import React, { useState } from "react";

import { Switch, FormControlLabel, FormGroup } from "@mui/material";

import useUiStore from "../../../../stores/useUiStore";

const Switches = () => {
  const paramsTholos = useUiStore((state) => state.paramsTholos);
  const setParamsTholos = useUiStore((state) => state.setParamsTholos);
  const config = useUiStore((state) => state.config);

  const MySwitch = (props) => {
    const { field, value, ...previousProps } = props;
    const { label } = previousProps;

    const [localValue, setLocalValue] = useState(value);

    const handleValue = (e) => {
      setLocalValue(e.target.checked);

      //   setParamsTholos({
      //     ...paramsTholos,
      //     [field]: { ...previousProps, value: !value },
      //   });
      setParamsTholos({
        ...paramsTholos,
        [field]: { ...previousProps, value: e.target.checked },
      });
    };

    return (
      <FormControlLabel
        labelPlacement="start"
        control={
          <Switch
            size="small"
            checked={localValue}
            onChange={handleValue}
            sx={{ mx: 1 }}
          />
        }
        label={label}
      />
    );
  };

  return (
    <FormGroup row>
      {Object.keys(paramsTholos)
        .filter((item) => paramsTholos[item].type === "switch")
        .filter((item) => {
          if (config.modeAdmin) {
            return item;
          } else {
            return paramsTholos[item].admin != true;
          }
        })
        .map((item, index) => (
          <MySwitch key={index} field={item} {...paramsTholos[item]} />
        ))}
    </FormGroup>
  );
};

export default Switches;
